export default __webpack_public_path__ + "static/media/heart.9c6c3e43.png";